export default __webpack_public_path__ + "locales/zh-CN/EmptyView.json?hash=139584a8e10f0ddf7cd3c334eb374012";